import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


(($) => {

//global reveal triggers - actual effect controlled via patterns css
const reveal = gsap.utils.toArray('.js-trigger-reveal');
reveal.forEach(reveal => {

    // Content Reveal Animation
    ScrollTrigger.create({
        start: "top bottom-=200px", //200px from the bottom
        trigger: reveal,
        onEnter: ({progress, direction, isActive}) => reveal.classList.add('revealed'),
        onLeaveBack: ({progress, direction, isActive}) => reveal.classList.remove('revealed'),
        // markers: {startColor: "blue", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20}
    });

});

//MOVEMENT EFFECTS

ScrollTrigger.matchMedia({

    // desktop
    "(min-width: 1024px)": function() {
        // setup animations and ScrollTriggers for screens 1000px wide or greater (desktop) here...
        // These ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
        
        //Content Image Row
        const contentFeatureImage = gsap.utils.toArray('.js-image-row-parallax');
        contentFeatureImage.forEach(contentFeatureImage => {

            var topImage = contentFeatureImage.querySelector('.img-wrapper');

            gsap.to(topImage, {
                scrollTrigger: {
                    trigger: contentFeatureImage,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    markers: false
                },
                y: -40
            });
        });

        //CTA
        const ctaBackgroundImage = gsap.utils.toArray('.js-bg-cta-parallax');
        ctaBackgroundImage.forEach(ctaBackgroundImage => {

            var topImage =ctaBackgroundImage.querySelector('.cta__background');

            gsap.to(topImage, {
                scrollTrigger: {
                    trigger: ctaBackgroundImage,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    markers: false
                },
                y: -250
            });
        });

        //Interior Hero
        const heroBackgroundImage = gsap.utils.toArray('.js-bg-hero-interior-parallax');
        heroBackgroundImage.forEach(heroBackgroundImage => {

            var topImage = heroBackgroundImage.querySelector('.hero-interior__background');

            gsap.to(topImage, {
                scrollTrigger: {
                    trigger: heroBackgroundImage,
                    start: "center center",
                    end: "bottom top",
                    scrub: true,
                    markers: false
                },
                y: -100
            });
        });

    },
    "(min-width: 768px) and (max-width: 1023px)": function(){
        //tablet only
        const contentFeatureImage = gsap.utils.toArray('.js-image-row-parallax');
        contentFeatureImage.forEach(contentFeatureImage => {

            var topImage = contentFeatureImage.querySelector('.img-wrapper');

            gsap.to(topImage, {
                scrollTrigger: {
                    trigger: contentFeatureImage,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    markers: false
                },
                y: -30
            });

            const ctaBackgroundImage = gsap.utils.toArray('.js-bg-cta-parallax');
            ctaBackgroundImage.forEach(ctaBackgroundImage => {
    
                var topImage =ctaBackgroundImage.querySelector('.cta__background');
    
                gsap.to(topImage, {
                    scrollTrigger: {
                        trigger: ctaBackgroundImage,
                        start: "top bottom",
                        end: "bottom bottom-=300px",
                        scrub: true,
                        markers: false
                    },
                    y: -250
                });
            });

            const heroBackgroundImage = gsap.utils.toArray('.js-bg-hero-interior-parallax');
            heroBackgroundImage.forEach(heroBackgroundImage => {

                var topImage = heroBackgroundImage.querySelector('.hero-interior__background');

                gsap.to(topImage, {
                    scrollTrigger: {
                        trigger: heroBackgroundImage,
                        start: "center center",
                        end: "bottom top",
                        scrub: true,
                        markers: false
                    },
                    y: -100
                });
            });

        });
    }
});


})(jQuery)